import { render, staticRenderFns } from "./expenditure.vue?vue&type=template&id=7db963a0&scoped=true&"
import script from "./expenditure.vue?vue&type=script&lang=js&"
export * from "./expenditure.vue?vue&type=script&lang=js&"
import style0 from "./expenditure.vue?vue&type=style&index=0&id=7db963a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db963a0",
  null
  
)

export default component.exports